import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from '@/hooks/use-toast';
import NavbarView from './navbar.view';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast({
      title: 'Одјавени сте',
      description: 'Успешно се одјавивте од вашиот профил.'
    });
    navigate('/');
  };

  return (
    <NavbarView
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
      user={user}
      isAuthenticated={isAuthenticated}
      handleLogout={handleLogout}
      navigate={navigate}
    />
  );
};

export default Navbar;
